import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { stringify } from 'hub-http/helpers/params';
import { buildUrl, parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
import devLogger from 'react-utils/devLogger';
import { PROD, QA } from 'self-service-api/constants/Environments';
export const createExternalUrl = (path = '', query, subdomain = 'app') => {
  const {
    protocol,
    hostname
  } = parseUrl(getFullUrl(subdomain));
  const urlOptions = {
    protocol,
    hostname,
    path,
    query: stringify(query || {})
  };
  return buildUrl(urlOptions);
};
export const getInterstitialUrl = (query = {}, location = window.location) => {
  const isLocal = !enviro.deployed() && location.hostname.startsWith('local.');
  const isOnPricingPage = location.pathname.includes('pricing');
  const shouldUseLocal = isLocal && isOnPricingPage;
  const url = createExternalUrl(`/pricing/${PortalIdParser.get()}/interstitial`, query, shouldUseLocal ? 'local' : 'app');
  return url;
};
export const getCheckoutUrl = (purchaseOrderId, query = {}) => {
  return createExternalUrl(`/checkout/${PortalIdParser.get()}/purchases/${purchaseOrderId}`, query);
};
const baseUrlOptions = () => {
  const isQAProxy = window.location.hostname.indexOf('wthubspot') >= 0;
  const isQA = enviro.isQa() || isQAProxy;
  const baseUrl = getFullUrl('app', {
    envOverride: isQA ? QA : PROD
  });
  const {
    protocol,
    hostname
  } = parseUrl(baseUrl);
  return {
    protocol,
    hostname
  };
};
const _createPricingPageLink = (path = '', params, hash, isBeta = false) => {
  const portalId = PortalIdParser.get();
  if (params && !params.upgradeSource) {
    devLogger.warn({
      message: `createPricingPageLink: Expected upgradeSource for path ${path} but got ${params.upgradeSource}`,
      key: `createPricingPageLink: ${path}`
    });
  }
  const urlOptions = Object.assign({}, baseUrlOptions(), {
    path: `/${portalId ? 'pricing' : 'public-pricing'}${isBeta ? '-beta' : ''}/${portalId ? `${portalId}/` : ''}${path}`,
    query: params && stringify(params),
    hash: hash && hash.anchorLink ? hash.anchorLink : ''
  });
  return buildUrl(urlOptions);
};
export const navigateTo = (url, openInNewTab = false) => {
  if (window.hubspot.wordpress) {
    window.open(url, '_top');
  } else if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};
export const getSupportUrl = () => {
  return createExternalUrl(`/support-inbox/${PortalIdParser.get()}?source=in-app-help`);
};
export const getAccountDashboardUrl = () => createExternalUrl(`/account-and-billing/${PortalIdParser.get()}`);
export const getTrialUpgradePageUrl = apiName => {
  return buildUrl({
    path: `/trial-pricing/${PortalIdParser.get()}/upgrade`,
    query: `apiName=${apiName}`
  });
};
export const getUpgradePageUrl = (upgradeSource, params) => {
  return _createPricingPageLink(`upgrade`, Object.assign({
    upgradeSource
  }, params));
};